import { render, staticRenderFns } from "./MainSupplier.vue?vue&type=template&id=e87bb0fc&"
import script from "./MainSupplier.vue?vue&type=script&lang=js&"
export * from "./MainSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports